<template>
    <div v-if="errors && errors.length" class="input-error">
        <Nl2Br
            v-for="error in errors"
            :key="error"
            :text="getValueByKey(error, jsonKey)"
            tag="small"
            class-name="text-danger"
            >
        </Nl2Br>
    </div>
</template>

<script>
import Nl2Br from '@/components/Nl2Br.vue'

export default {
    components: {
        Nl2Br,
    },
    props: {
        errors: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        jsonKey: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
    },
    data() {
        return {}
    },
    computed: {},
    async mounted() {},
    methods: {
        getValueByKey(value, key) {
            let arr
            try {
                arr = JSON.parse(value)
            } catch (e) {}
            if (typeof arr !== 'object') {
                return value
            }
            return Array.isArray(arr[key]) ? arr[key].join('\n') : arr[key] || ''
        },
    },
}
</script>

<style lang="scss" scoped>
.input-error {
    small {
        display: block;
    }
}
</style>

